var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import { Container } from '../../uikit/grid';
import { MainLayout } from '../../components/layouts/MainLayout';
import { ClientOnlyContent } from '../../components/atoms/ClientOnlyContent';
import { initialDataSlice } from '../../store/initialData/initialData.slice';
import constants from './constants';
import { GAService } from '../../services/GAService';
import { useGAEventMeta } from '../../hooks/useGAEventMeta.hook';
import { useAudienceMarker } from '../../hooks/useAudienceMarker.hook';
import useEmotionStyles from '../../uikit/hooks/useEmotionStyles';
import { roundTo } from '../../utils/misc/roundTo.utils';
var styles = function (theme) {
    var _a;
    return ({
        iframe: (_a = {
                width: '100%',
                border: 'none',
                height: '2800px'
            },
            _a[theme.breakpoints.up('lg')] = {
                height: '2000px',
            },
            _a),
    });
};
function getPredefinedValues(loanAmount) {
    if (typeof loanAmount === 'undefined') {
        return { purchasePrice: 300000, ownFunds: 50000 };
    }
    if (loanAmount > 100000) {
        return {
            purchasePrice: loanAmount,
            ownFunds: roundTo(loanAmount * 0.2, 10000),
        };
    }
    return { purchasePrice: loanAmount, ownFunds: 0 };
}
var mapStateToProps = function (state) { return ({
    initialLoanAmount: initialDataSlice.selectors.getAmount(state),
    placementId: initialDataSlice.selectors.getPlacementId(state),
}); };
function RawBaufiImmoScoutPage(_a) {
    var initialLoanAmount = _a.initialLoanAmount, placementId = _a.placementId;
    var lastStep = useRef(0);
    var gaEventMeta = useGAEventMeta();
    var audienceMarker = useAudienceMarker();
    var precisedSrc = useMemo(function () {
        var iframeSrc = constants.iframeSrc;
        var _a = getPredefinedValues(initialLoanAmount), purchasePrice = _a.purchasePrice, ownFunds = _a.ownFunds;
        var queryParams = new URLSearchParams(__assign({ purchaseprice: String(purchasePrice), ownfunds: String(ownFunds) }, (audienceMarker !== null && {
            partnerTracking: audienceMarker,
        })));
        return "".concat(iframeSrc, "?").concat(queryParams.toString());
    }, [audienceMarker]);
    var ref = useRef(null);
    var handleIframeResize = useCallback(function (height) {
        if (ref.current === null) {
            return;
        }
        ref.current.style.height = "".concat(height, "px");
    }, []);
    var handleStepChange = useCallback(function (eventName) {
        // @note: what solution will work only for https://baufi.smava.de
        var stepIndex = [
            'scoutMortgagePageview.finanzcheck.financingrequest.financingdata',
            'scoutMortgagePageview.finanzcheck.financingrequest.personaldata',
            'scoutMortgagePageview.finanzcheck.financingrequest.solvencydata',
            'scoutMortgageLeadCreated',
        ].indexOf(eventName);
        var activeStep = stepIndex === -1 ? stepIndex : stepIndex + 1;
        if (activeStep !== -1) {
            if (lastStep.current === activeStep) {
                return;
            }
            if (activeStep === 4) {
                GAService.onLeadCreated(placementId, gaEventMeta);
            }
            else {
                GAService.onVirtualPageEnter("/page".concat(activeStep), gaEventMeta);
            }
            lastStep.current = activeStep;
        }
    }, [placementId, gaEventMeta]);
    var handleImmoscoutMessage = useCallback(function (ev) {
        if (typeof ev.data === 'string') {
            var data = null;
            try {
                data = JSON.parse(ev.data);
            }
            finally {
                if (data !== null && typeof data.event === 'string') {
                    handleStepChange(data.event);
                }
            }
        }
        if (ev.data.source !== 'ImmoScoutIframe' || !ev.data.messageType) {
            return;
        }
        if (ev.data.messageType === 'onHeightChange') {
            handleIframeResize(ev.data.payload.height);
        }
    }, [handleIframeResize, handleStepChange]);
    useEffect(function () {
        window.addEventListener('message', handleImmoscoutMessage);
        return function () {
            window.removeEventListener('message', handleImmoscoutMessage);
        };
    }, []);
    var cs = useEmotionStyles(styles);
    return (React.createElement(MainLayout, null,
        React.createElement(Container, { disableGutters: true },
            React.createElement(ClientOnlyContent, null,
                React.createElement("iframe", { src: precisedSrc, ref: ref, scrolling: "no", height: "1700", className: cs.iframe })))));
}
export var BaufiImmoScoutPage = connect(mapStateToProps)(RawBaufiImmoScoutPage);
